import React, { Component } from 'react';
import ClassNames from 'classnames';

class SelectBox extends Component {
  constructor(props) {
    super(props);
    let {
      mainStyles = {},
      labelFrameStyles = {},
      labelCellStyles = {},
      labelCellButtonStyles = {},
      defaultSelected = '선택',
    } = this.props;
    this.state = {
      isOn: false,
      mainStyles: mainStyles,
      labelFrameStyles: labelFrameStyles,
      labelCellStyles: labelCellStyles,
      labelCellButtonStyles: labelCellButtonStyles,
      selected: defaultSelected,
      defaultSelected: defaultSelected,
      isRefresh: false,
    };
    this.onSelect = this.onSelect.bind(this);
    this.decideLabel = this.decideLabel.bind(this);
  }

  onSelect(selected) {
    let { onSelected } = this.props;
    let targetLabel = this.decideLabel(selected);
    this.setState(
      {
        selected: targetLabel,
        isOn: false,
      },
      () => {
        if (onSelected) {
          onSelected(selected);
        }
      }
    );
  }

  decideLabel(item) {
    let targetLabel = '';
    if ('string' === typeof item) {
      targetLabel = item;
    }
    if ('object' === typeof item) {
      if (item?.name) {
        targetLabel = item.name;
      } else if (item?.label) {
        targetLabel = item.label;
      }
    }

    return targetLabel;
  }

  componentWillUnmount() {
    clearTimeout(this.setTimeoutButton);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultSelected &&
      this.state.defaultSelected !== nextProps.defaultSelected
    ) {
      this.setState({
        defaultSelected: nextProps.defaultSelected,
        selected: nextProps.defaultSelected,
      });
    } else if (this.props.labels.length !== nextProps.labels.length) {
      if (0 !== this.props.labels.length && 0 !== nextProps.labels.length) {
        if (this.props.labels[0].id !== nextProps.labels[0].id) {
          this.setState({
            selected: '선택',
          });
        }
      }
    }
  }

  render() {
    let {
      isOn,
      mainStyles,
      labelFrameStyles,
      labelCellStyles,
      labelCellButtonStyles,
      selected,
    } = this.state;
    const { labels = [], disabled = false, size } = this.props;

    const sizeClass = size ? `size-${size}` : null;

    return (
      <div
        className={ClassNames('select-mode', sizeClass, { on: isOn })}
        style={mainStyles}
        onMouseEnter={(e) => {
          clearTimeout(this.setTimeoutButton);
        }}
        onMouseLeave={() => {
          clearTimeout(this.setTimeoutButton);
          this.setTimeoutButton = setTimeout(() => {
            this.setState({ isOn: false });
          }, 500);
        }}
      >
        <button
          onClick={() => {
            if (!disabled) {
              this.setState({ isOn: !isOn });
            } else {
              if (this.state.isOn) {
                this.setState({
                  isOn: false,
                });
              }
            }
          }}
        >
          {/*{defaultSelected === this.state.defaultSelected? selected : defaultSelected}*/}
          <i>{selected}</i>
        </button>
        <div style={labelFrameStyles}>
          <ul>
            {labels &&
              Array.isArray(this.props.labels) &&
              labels.map((item, index) => {
                let targetLabel = this.decideLabel(item);

                return (
                  <li key={index} style={labelCellStyles}>
                    <button
                      onClick={() => {
                        this.onSelect(item);
                      }}
                      style={labelCellButtonStyles}
                    >
                      <i>{targetLabel}</i>
                    </button>
                  </li>
                );
              })}
          </ul>
        </div>
        {/*INLINE_STYLE*/}
        {isOn ? <span className="shadow" style={{ height: 154 }}></span> : null}
      </div>
    );
  }
}

export default SelectBox;
